import script from "./UploadCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadCard.vue?vue&type=script&setup=true&lang=ts"

import "./UploadCard.vue?vue&type=style&index=0&id=39dcaa78&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39dcaa78"]])

export default __exports__